import styled from "styled-components";

const Etiqueta = styled.label`
  font-weight: bold;
`;

export default Etiqueta;
